import { render, staticRenderFns } from "./PageEditProfileEmail.vue?vue&type=template&id=28ae7c2d&scoped=true&"
import script from "./PageEditProfileEmail.vue?vue&type=script&lang=js&"
export * from "./PageEditProfileEmail.vue?vue&type=script&lang=js&"
import style0 from "./PageEditProfileEmail.vue?vue&type=style&index=0&id=28ae7c2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae7c2d",
  null
  
)

export default component.exports